import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Form, Input, message } from "antd";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonDefault, ButtonPrimary } from "../../components/buttons/ButtonPrimary";
import { GuestLayout } from "../../components/layout/guestLayout";
import { GuestCard } from "../../components/styled-components";
import { Dashboard_ROLE } from "../../constants/menu";
import { color } from "../../res/color";
import { PATHNAME } from "../../res/pathName";
import { POST } from "../../services";
import { AUTH_LOGIN, AUTH_LOGIN_LARK } from "../../services/path";

const Auth = () => {
  const navigate = useNavigate();
  const [loadingBtn, setLoadingBtn] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const cookies = Cookies.get("jwt");
  const lark_token = queryParams.get("token");
  const onLogin = async (values: any) => {
    try {
      setLoadingBtn(true);
      const response = await POST(AUTH_LOGIN, {
        username: values.username,
        password: values.password,
      });

      const roleId = response.role_id;
      navigate(Dashboard_ROLE[roleId]);
      setLoadingBtn(false);
      localStorage.removeItem("packStationID");
    } catch (error) {
      console.error(error);
      message.error("เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      setLoadingBtn(false);
    }
  };

  const onLoginLark = async (token: any) => {
    try {
      setLoadingBtn(true);
      const decode: any = jwtDecode(token);
      const jsonObject = JSON.parse(decode);
      if (decode) {
        await POST(AUTH_LOGIN_LARK, {
          user_id: jsonObject.user_id,
          username: jsonObject.username,
        });

        navigate(PATHNAME.RESERVE_STOCK);
      }
    } catch (error) {
      console.error(error);
      message.error("เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      setLoadingBtn(false);
    }
  };

  useEffect(() => {
    if (cookies) {
      navigate(PATHNAME.RESERVE_STOCK);
      message.warning("กรุณาออกจากระบบก่อน");
    } else if (lark_token) {
      onLoginLark(lark_token);
    }
  }, []);

  return (
    <GuestLayout>
      <GuestCard
        title={
          <img
            src={process.env.REACT_APP_FRONTEND_URL + "/logo_uplift_3.jpg"}
            style={{ width: 300 }}
            alt={process.env.REACT_APP_FRONTEND_URL + "/logo_uplift_3.jpg"}
          />
        }
        style={{ textAlign: "center" }}
      >
        <Form onFinish={onLogin}>
          <Form.Item
            name={"username"}
            style={{ maxWidth: 350 }}
            rules={[
              { required: true, message: "กรุณากรอกชื่อผู้ใช้" },
              {
                pattern: /^[a-zA-Z0-9_.@]+$/,
                message: "ใช้เฉพาะตัวอักษร(a-z), ตัวเลข(0-9), และเครื่องหมายมหัพภาค(.) เท่านั้น",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined style={{ color: color.DISABLED }} />}
              placeholder="ชื่อผู้ใช้"
            />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: "กรุณากรอกรหัสผ่าน" }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: color.DISABLED }} />}
              placeholder="รหัสผ่าน"
            />
          </Form.Item>
          <p
            style={{
              marginTop: -10,
              textAlign: "right",
              textDecoration: "underline",
            }}
          >
            <a href="/login">ลืมรหัสผ่าน?</a>
          </p>
          <Form.Item style={{ textAlign: "center" }}>
            <ButtonPrimary type="primary" htmlType="submit" loading={loadingBtn}>
              เข้าสู่ระบบ
            </ButtonPrimary>
          </Form.Item>
          <Form.Item style={{ textAlign: "center", marginTop: "-10px" }}>
            <ButtonDefault href="/batch-instant" loading={loadingBtn}>
              Batch Instant
            </ButtonDefault>
          </Form.Item>
        </Form>
      </GuestCard>
    </GuestLayout>
  );
};

export default Auth;
